import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { UpdateIoSettings, UpdateUserSettings } from "../../database/userInfo";
import "./ioname.css";
import { SettingsContext } from "../../Navbar/settingsContext";
import { getTranslations } from "../../Shared/translations";

interface IoSettings {
  ruimte: boolean;
  uitgang: boolean;
  leemaken: boolean;
}

interface MyProps {
  onNameChange: (name: string) => void;
  onAantalChange: (aantal: number) => void;
  onEigenNaamCheckChange: (checked: boolean) => void;
  onUitgangNaamCheckChange: (checked: boolean) => void;
  onRuimtenNaamCheckChange: (checked: boolean) => void;
}

const IoName: React.FC<MyProps> = (props) => {
  const t = getTranslations();

  const [outpName, setOutpName] = useState("");
  const [aantalIos, setAantalIos] = useState(1);
  const [outputNameChecked, setOutputNameChecked] = useState(false);
  const [outputNameClearChecked, setOutputNameClearChecked] = useState(false);
  const [ruimteNaamCheck, setRuimteNaamCheck] = useState(false);

  const prevOutpName = useRef(outpName);
  const prevAantalIos = useRef(aantalIos);
  /*
  const [ioSettings, setIoSettings] = useState<IoSettings>({
  ruimte: false,
  uitgang: false,
  leemaken: false,
});
*/
  const context = useContext(SettingsContext);
  if (!context)
    throw new Error("ChildComponent must be inside SettingsProvider");

  const { ioSettings, setIoSettings } = context;

  const initialized = React.useRef(false);

  useEffect(() => {
    if (!ioSettings || initialized.current) return;

    //setLocalSettings(ioSettings);
    setOutputNameChecked(ioSettings.uitgang);
    setOutputNameClearChecked(ioSettings.leemaken);
    setRuimteNaamCheck(ioSettings.ruimte);
    initialized.current = true;
  }, [ioSettings]);

  useEffect(() => {
    const prevName = prevOutpName.current;
    const prevAantal = prevAantalIos.current;

    if (prevName === outpName && prevAantal === aantalIos) {
      if (outputNameClearChecked && outpName !== "") {
        setOutpName("");
        props.onNameChange("");
      }

      if (aantalIos !== 1) {
        setAantalIos(1);
        props.onAantalChange(1);
      }
    }

    prevOutpName.current = outpName;
    prevAantalIos.current = aantalIos;
  }, [outpName, aantalIos, outputNameClearChecked, props]);

  const saveSettings = async (ios: {
    ruimte: boolean;
    uitgang: boolean;
    leemaken: boolean;
  }) => {
    try {
      const created = await UpdateIoSettings(ios);
      console.log("Settings updated:", created);
    } catch (error) {
      console.error("Fout bij opslaan van settings:", error);
    }
  };

  const onNaamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const naamText = event.target.value;
    props.onNameChange(naamText);
    setOutpName(naamText);
  };

  const onAantalChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const aantal = Number(event.target.value);
    setAantalIos(aantal);
    props.onAantalChange(aantal);
  };

  const outputsUp = () => {
    setAantalIos((prev) => {
      const newAantal = prev + 1;
      props.onAantalChange(newAantal);
      return newAantal;
    });
  };

  const outputsDown = () => {
    setAantalIos((prev) => {
      const newAantal = prev - 1 <= 0 ? 1 : prev - 1;
      props.onAantalChange(newAantal);
      return newAantal;
    });
  };

  const onRuimtenNaamCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    props.onRuimtenNaamCheckChange(checked);
    // update context immediately
    setIoSettings((prev) => {
      if (!prev) return null; // optional guard
      return { ...prev, ruimte: checked }; // ✅ keeps other fields
    });

    setRuimteNaamCheck(checked);
    saveSettings({ ...ioSettings!, ruimte: checked });
  };

  const onUitgangNaamCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    props.onUitgangNaamCheckChange(checked);
    setIoSettings((prev) => {
      if (!prev) return null; // optional guard
      return { ...prev, uitgang: checked }; // ✅ keeps other fields
    });
    setOutputNameChecked(checked);
    saveSettings({ ...ioSettings!, uitgang: checked });
  };

  const onUitgangNaamClearCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    props.onUitgangNaamCheckChange(checked); // Confirm if this is the correct prop
    setIoSettings((prev) => {
      if (!prev) return null; // optional guard
      return { ...prev, leemaken: checked }; // ✅ keeps other fields
    });
    setOutputNameClearChecked(checked);
    saveSettings({ ...ioSettings!, leemaken: checked });
  };

  return (
    <div className="ionames">
      <Form.Group>
        <Row>
          <Col>
            <Form.Label>{t.naam}</Form.Label>
            <Form.Control
              id="ruimtenaam"
              onChange={onNaamChange}
              style={{ width: "250px" }}
              value={outpName}
            />
          </Col>

          <Col>
            <Form.Label>{t.aantal}</Form.Label>
            <Form.Control
              id="aantalOutputs"
              onChange={onAantalChange1}
              style={{ width: "50px" }}
              value={aantalIos}
              type="number"
            />
          </Col>

          <Col>
            <Button className="btnUp" onClick={outputsUp}>
              +
            </Button>
            <Button className="btnUp" onClick={outputsDown}>
              -
            </Button>
          </Col>
        </Row>

        <Row>
          <Col md="auto">
            <Form.Check type="checkbox" id="check-api-checkbox2">
              <Form.Check.Input
                type="checkbox"
                name="ruimtenaam"
                onChange={onRuimtenNaamCheckChange}
                checked={ioSettings?.ruimte}
              />
              <Form.Check.Label className="label">{t.ruimte}</Form.Check.Label>
            </Form.Check>
          </Col>

          <Col md="auto">
            <Form.Check type="checkbox" id="check-api-checkbox">
              <Form.Check.Input
                checked={outputNameChecked}
                type="checkbox"
                name="uitgangnaam"
                onChange={onUitgangNaamCheckChange}
              />
              <Form.Check.Label className="label">{t.uitgang}</Form.Check.Label>
            </Form.Check>
          </Col>

          <Col md="auto">
            <Form.Check type="checkbox" id="check-api-checkbox3">
              <Form.Check.Input
                checked={outputNameClearChecked}
                type="checkbox"
                name="uitgangnaamclear"
                onChange={onUitgangNaamClearCheckChange}
              />
              <Form.Check.Label className="label">{t.maakNaamLeeg}</Form.Check.Label>
            </Form.Check>
          </Col>
        </Row>
      </Form.Group>
    </div>
  );
};

export default IoName;
